import { Stack, styled } from "@mui/material";

export const AuthenticatedErrorWrapper = styled(Stack)(() => {
	return {
		gap: "var(--flex-gap)",
		padding: "var(--basic-padding)",
		backgroundColor: "var(--light-color)",
		borderRadius: "16px",
		overflow: "hidden",
		"& .icon-box, & .header-box, & .body-box, & .call-to-action-box": {
			display: "flex",
			justifyContent: "center",
			overflow: "hidden",
		},
	};
});
